import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from "@emotion/styled";
import classNames from "classnames";
const StyledFlexBox = styled("div")(({ direction, justifyContent, alignItems, wrap, spacing, style }) => {
    return {
        display: "flex",
        flexDirection: direction !== null && direction !== void 0 ? direction : "row",
        justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : "flex-start",
        alignItems: alignItems !== null && alignItems !== void 0 ? alignItems : "flex-start",
        flexWrap: wrap !== null && wrap !== void 0 ? wrap : "nowrap",
        gap: `${spacing !== null && spacing !== void 0 ? spacing : 0}px`,
        ...style,
    };
});
/**
 *
 * @deprecated Use GrStack instead of GrFlexBox (duplicated component)
 */
export function GrFlexBox(props) {
    const { className, direction, justifyContent, alignItems, wrap, spacing, style, children } = props;
    return (_jsx(StyledFlexBox, { className: classNames("GrFlexBox", className), direction: direction, justifyContent: justifyContent, alignItems: alignItems, wrap: wrap, spacing: spacing, style: style, children: children }));
}
//# sourceMappingURL=GrFlexBox.js.map